/**
 * Map a HashRouter pathname to the Topbar title. Pure (no React imports) so it
 * is unit-testable without mounting the Dashboard layout.
 *
 * NOTE: `/sandbox` needs its own branch — without it the sandbox route falls
 * through to the "Dashboard" default even though the Sandbox Control page is the
 * one actually rendering (the route is only present in SANDBOX_BUILD admin
 * bundles).
 */
export function getPageTitle(pathname: string): string {
  if (pathname === "/" || pathname === "") return "Dashboard";
  if (pathname.startsWith("/company")) return "Company";
  if (pathname.startsWith("/fds")) return "FDS";
  if (pathname.startsWith("/logs")) return "Logs";
  if (pathname.startsWith("/sandbox")) return "Sandbox Control";
  return "Dashboard";
}
